import { Switch as MuiSwitch } from '@mui/material';
import { FormControlLabel } from './FormControlLabel';
import type { SxProps, Theme } from '@mui/material/styles';
import type { SwitchProps as MuiSwitchProps } from '@mui/material/Switch';

const compactSwitchSx: SxProps<Theme> = {
  transform: 'scale(0.85)',
  transformOrigin: 'center right',
};

export type SwitchProps = MuiSwitchProps & {
  label?: string;
  density?: 'default' | 'compact';
};

export const Switch = ({ label, density = 'default', sx, ...rest }: SwitchProps): JSX.Element => {
  const resolvedSx =
    density === 'compact'
      ? ([compactSwitchSx, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])] as SxProps<Theme>)
      : sx;
  const control = <MuiSwitch {...rest} sx={resolvedSx} />;

  return label ? <FormControlLabel control={control} label={label} /> : control;
};
